import React from 'react';
import get from 'lodash/get';
import DynamicAnchor from '../components/ui/DynamicAnchor';

/**
 * Class used to avoid issues in the project when rendering from SSR.
 * Taken from https://asmagin.com/2019/01/18/catching-server-side-rendering-errors-in-react-jss-apps/
 */
export class SafePureComponent extends React.PureComponent {
  hasError = false;
  paramData = {};

  componentDidMount() {
    this.setState({ hasError: this.hasError });

    this.prepareAnchorDynamicData();
  }

  prepareAnchorDynamicData = () => {
    const ssrRawJson = document.getElementById('__JSS_STATE__');

    if (ssrRawJson) {
      let ssrRawJsonParse = JSON.parse(ssrRawJson.innerHTML);

      this.paramData = {
        locale: get(ssrRawJsonParse, 'sitecore.context.language', ''),
        countryCode: get(
          ssrRawJsonParse,
          'sitecore.context.countryCode.countryCode',
          '',
        ),
        location: '',
        countryName: get(
          ssrRawJsonParse,
          'sitecore.context.countryName.countryName',
          '',
        ),
        location: '',
      };
    }
  };

  componentDidUpdate() {
    let allAnchor = document.querySelectorAll('a:not(.updated)');

    for (let i = 0; i < allAnchor.length; i++) {
      allAnchor[i].classList.add('updated');
      let anchorHref = allAnchor[i].href;
      if (anchorHref && anchorHref.includes('{') && anchorHref.includes('?')) {
        allAnchor[i].href = DynamicAnchor(anchorHref, this.paramData);
      }
    }
  }

  render() {
    // componentDidCatch doesn't work in React 16's renderToString
    // https://github.com/facebook/react/issues/10442
    // Due to streaming nature of renderToString in React 16, need to wrap each render method in try/catch
    try {
      // Using error boundaries for client-side rendering
      if (this.state && this.state.hasError) {
        return this.renderErrorView();
      }

      return this.safeRender();
    } catch (error) {
      // this allows to differentiate server vs client rendering
      if (typeof window !== 'undefined' || process.env.NODE_ENV === 'test') {
        // used to avoid side-effects via setState()
        this.hasError = true;
        //eslint-disable-next-line no-console
        console.error('Error inside', this.getComponentName(), 'is', error);
      }

      return this.renderErrorView();
    }
  }

  // this method should be overridden in nested classes
  safeRender() {
    return (
      <span
        dangerouslySetInnerHTML={{
          __html: `<!-- Component ${this.getComponentName()} is not implemented. -->`,
        }}
      />
    );
  }

  renderErrorView() {
    return (
      <span
        dangerouslySetInnerHTML={{
          __html: `<!-- Error inside ${this.getComponentName()}. For more info, please, check the console."-->`,
        }}
      />
    );
  }

  getComponentName() {
    const component = this.constructor;
    return (
      get(component, 'displayName') || get(component, 'name') || 'Component'
    );
  }
}
